var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCampaignHeaderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7294",
    "data-name": "Group 7294",
    transform: "translate(10.228 10.227)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1071",
    "data-name": "Rectangle 1071",
    width: 42.271,
    height: 42.271,
    transform: "translate(-4.223 -4.223)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "brightness_auto-24px",
    transform: "translate(-10.228 -10.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M0,0H27.057V27.057H0Z",
    transform: "translate(13.472 13.472)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M19.092,0,24.68,5.588H32.6V13.5l5.588,5.588L32.6,24.68V32.6H24.68l-5.588,5.588L13.5,32.6H5.588V24.68L0,19.092,5.588,13.5V5.588H13.5ZM29.245,8.939h-6.2L19.092,4.982,15.135,8.939h-6.2v6.2L4.982,19.092l3.957,3.957v6.2h6.2l3.542,4.372,4.372-4.372h6.2v-6.2L33.2,19.092l-3.957-3.957Z",
    transform: "translate(27 0) rotate(45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_953",
    "data-name": "Path 953",
    d: "M11.246-20.216H13.3L6.775-7.92H4.72ZM7.514-16.8a3.344,3.344,0,0,1-.732,2.3,2.638,2.638,0,0,1-2.079.822,2.659,2.659,0,0,1-2.1-.822,3.344,3.344,0,0,1-.732-2.3,3.314,3.314,0,0,1,.74-2.31A2.678,2.678,0,0,1,4.7-19.92a2.657,2.657,0,0,1,2.071.814A3.314,3.314,0,0,1,7.514-16.8ZM4.7-15.1a.572.572,0,0,0,.444-.205,1.1,1.1,0,0,0,.2-.526,6.617,6.617,0,0,0,.049-.912,8.153,8.153,0,0,0-.041-.921,1.411,1.411,0,0,0-.189-.584.5.5,0,0,0-.46-.238.554.554,0,0,0-.584.452A4.512,4.512,0,0,0,4-16.879a5.567,5.567,0,0,0,.082,1.093,1.084,1.084,0,0,0,.23.534A.533.533,0,0,0,4.7-15.1Zm11.359,3.764a3.363,3.363,0,0,1-.723,2.31,2.647,2.647,0,0,1-2.088.814,2.664,2.664,0,0,1-2.088-.822,3.32,3.32,0,0,1-.74-2.3,3.338,3.338,0,0,1,.732-2.31,2.652,2.652,0,0,1,2.079-.814,2.678,2.678,0,0,1,2.088.814A3.314,3.314,0,0,1,16.062-11.339ZM13.251-9.646a.551.551,0,0,0,.395-.14.962.962,0,0,0,.222-.51,5.642,5.642,0,0,0,.074-1.044,5.621,5.621,0,0,0-.074-1.052.911.911,0,0,0-.23-.5.605.605,0,0,0-.419-.14.492.492,0,0,0-.46.263,1.52,1.52,0,0,0-.181.608q-.033.345-.033.822a7.966,7.966,0,0,0,.041.9,1.222,1.222,0,0,0,.2.567A.535.535,0,0,0,13.251-9.646Z",
    transform: "translate(7.918 31.131)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignHeaderIcon);
export default __webpack_public_path__ + "static/media/campaignHeaderIcon.bac1535009a158110fef5dbf970ceb67.svg";
export { ForwardRef as ReactComponent };